<template>
    <div class="new-item">
        <div class="ribbon" v-if="ribbonText">{{ ribbonText }}</div>
        <div class="new-item-title">
            {{ title }}
            <span>{{ ticket }}</span>
        </div>
        <div class="new-item-description">
            <p v-html="description"></p>

            <button class="link-btn" @click="clickLine" v-if="newsLink">
                {{ newsLink }}
                <span>↗</span>
            </button>
        </div>
        <div class="new-item-date">📅 {{ date }}</div>
    </div>
</template>

<script>
export default {
    name: "ItemNewsModal",
    props: {
        title: {
            type: String,
            default: "",
        },
        ticket: {
            type: String,
            default: "",
        },
        description: {
            type: String,
            default: "",
        },
        newsLink: {
            type: String,
            default: "",
        },
        date: {
            type: String,
            default: "",
        },
        linkText: {
            type: String,
            default: "",
        },
        ribbonText: {
            type: String,
            default: null,
        },
        onClicked: {
            type: Function,
            default: () => {},
        },
        onClick: {
            type: Function,
        },
    },
    methods: {
        clickLine() {
            if (typeof this.onClick === "function") {
                this.onClick();
            } else {
                const targetURL = `/${this.linkText}`;
                this.$router.push(targetURL);
            }
            this.onClicked();
        },
    },
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
    width: 0px;
    display: none;
}

.new-item {
    padding: 10px;
    border: 1px solid #e8e8e8;
    border-radius: 3px;
    margin-bottom: 10px;
    position: relative;

    &:last-child {
        margin-bottom: 0;
    }

    .new-item-title {
        font-weight: bold;
        font-size: 16px;
        margin: 5px;

        span {
            padding: 3px 7px;
            background-color: #d3e8db;
            margin-left: 5px;
            font-weight: normal;
            color: #313d33;
            font-size: 8px;

            &.Feature {
                background-color: #1890ff;
            }

            &.Update {
                background-color: purple;
            }
        }
    }

    .new-item-description {
        font-size: 12px;
        margin: 5px;
    }

    .new-item-date {
        font-size: 12px;
        color: #8c8c8c;
        margin: 5px;
    }

    .ribbon {
        --f: 0.5em; /* control the folded part*/
        --r: 0.8em; /* control the ribbon shape */

        position: absolute;
        top: 5px;
        right: calc(-1 * var(--f));
        padding-inline: 0.25em;
        line-height: 1.8;
        background: #ec4a1d;
        color: white;
        border-bottom: var(--f) solid #0005;
        border-left: var(--r) solid #0000;
        clip-path: polygon(
            0 0,
            100% 0,
            100% calc(100% - var(--f)),
            calc(100% - var(--f)) 100%,
            calc(100% - var(--f)) calc(100% - var(--f)),
            0 calc(100% - var(--f)),
            var(--r) calc(50% - var(--f) / 2)
        );
    }
}

.link-btn {
    background: transparent;
    color: #1890ff;
    border: none;
}
</style>
